import { useControl } from "@vis.gl/react-maplibre";
import type { ControlPosition } from "maplibre-gl";

/**
 * A slot in MapLibre's own control stack for a React control to portal into, so MapLibre lays it out,
 * spaces it and keeps it in fullscreen exactly like the zoom buttons, rather than it being placed by
 * hand over a canvas where every screen draws its own chrome.
 */
export const useMapLibreControlContainer = (
  position: ControlPosition,
): HTMLDivElement => {
  const control = useControl(
    () => {
      const container = document.createElement("div");
      container.className = "maplibregl-ctrl maplibregl-ctrl-group";

      return {
        container,
        onAdd: () => container,
        onRemove: () => container.remove(),
      };
    },
    { position },
  );

  return control.container;
};
